

//import '../../vendors/GridRevealEffects-master/js/generic.js';

import imagesLoaded from '../../vendors/GridRevealEffects-master/js/imagesloaded.pkgd.min.js';
import anime from '../../vendors/GridRevealEffects-master/js/anime.min.js';
console.log('prensa animation isra');
/**
 * demo4.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2019, Codrops
 * http://www.codrops.com
 */     
{
    const MathUtils = {
        lineEq: (y2, y1, x2, x1, currentVal) => {
            // y = mx + b 
            var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
            return m * currentVal + b;
        },
        lerp: (a, b, n) =>  (1 - n) * a + n * b
    };

    // Window size
    let winsize;
    const calcWinsize = () => winsize = {width: window.innerWidth, height: window.innerHeight};
    calcWinsize();
    window.addEventListener('resize', calcWinsize);
    const getMousePos = (ev) => {
        const { clientX, clientY } = ev;
    
        // Aquí, asegúrate de que `gridReveal` esté definido en el contexto correcto.
        // Puede ser necesario acceder a él de manera diferente dependiendo de cómo se haya declarado en tu código.
        const gridReveal = document.querySelector('.grid-reveal-custom');
        
        if (!gridReveal) {
            // Maneja la situación en la que no se pueda encontrar el elemento `gridReveal`.
            return { x: 0, y: 0 };
        }
        
        const { top, left } = gridReveal.getBoundingClientRect();
        const x = clientX - left;
        const y = clientY - top;
        return { x, y };
    };
    // Track the mouse position
    let mousePos = {x: winsize.width/2, y: winsize.height/2};
    window.addEventListener('mousemove', ev => mousePos = getMousePos(ev));
    
    // Custom mouse cursor.
    class CursorFx {
        constructor(el) {
            this.DOM = {el: el};
            this.DOM.toggle = this.DOM.el.querySelector('.cursor__inner--circle');
            this.DOM.title = this.DOM.el.querySelector('.cursor__inner--text');
            this.bounds = {
                toggle: this.DOM.toggle.getBoundingClientRect(),
                title: this.DOM.title.getBoundingClientRect()
            };
            this.lastMousePos = {
                toggle: {x: mousePos.x - this.bounds.toggle.width/2, y: mousePos.y - this.bounds.toggle.height/2},
                title: {x: mousePos.x - this.bounds.title.width/2, y: mousePos.y - this.bounds.title.height/2}
            };
            this.lastScale = 1;
            this.lastOpacity = 1;
            requestAnimationFrame(() => this.render());
        }
    
        render() {
            const diff = this.lastMousePos.toggle.x - (mousePos.x - this.bounds.toggle.width/2);
            const rightSide = mousePos.x >= winsize.width/2;
            this.DOM.title.style.left = rightSide ? 'auto' : '30px';
            this.DOM.title.style.right = rightSide ? '30px' : 'auto';
    
            const lerpFactor = {
                toggle: rightSide ? diff < 0 ? 0.15 : 0.1 : diff < 0 ? 0.1 : 0.15,
                title: rightSide ? diff < 0 ? 0.1 : 0.15 : diff < 0 ? 0.15 : 0.1
            };
    
            this.lastMousePos.toggle.x = MathUtils.lerp(this.lastMousePos.toggle.x, mousePos.x - this.bounds.toggle.width/2, lerpFactor.toggle);
            this.lastMousePos.toggle.y = MathUtils.lerp(this.lastMousePos.toggle.y, mousePos.y - (this.bounds.toggle.height/2) +950, lerpFactor.toggle);
            this.lastMousePos.title.x = MathUtils.lerp(this.lastMousePos.title.x, mousePos.x - this.bounds.title.width/2, lerpFactor.title);
            this.lastMousePos.title.y = MathUtils.lerp(this.lastMousePos.title.y, mousePos.y - (this.bounds.toggle.height/2) +950, lerpFactor.title);
    
            this.lastScale = MathUtils.lerp(this.lastScale, 1, 0.15);
            this.lastOpacity = MathUtils.lerp(this.lastOpacity, 1, 0.1);
    
            this.DOM.toggle.style.transform = `translateX(${(this.lastMousePos.toggle.x)}px) translateY(${this.lastMousePos.toggle.y}px) scale(${this.lastScale})`;
            this.DOM.toggle.style.opacity = this.lastOpacity;
            this.DOM.title.style.transform = `translateX(${(this.lastMousePos.title.x)}px) translateY(${this.lastMousePos.title.y}px)`;
    
            requestAnimationFrame(() => this.render());
        }
    
        setTitle(title) {
            this.DOM.title.innerHTML = title;
        }
    
        click() {
            this.lastScale = .5;
            this.lastOpacity = 0;
        }
    
        toggle() {
            const isCircle = this.DOM.toggle.classList.contains('cursor__inner--circle');
            this.DOM.toggle.classList[isCircle ? 'remove' : 'add']('cursor__inner--circle');
            this.DOM.toggle.classList[isCircle ? 'add' : 'remove']('cursor__inner--cross');
            this.DOM.title.style.opacity = isCircle ? 0 : 1;
        }
    }
    
    
    const cursor = new CursorFx(document.querySelector('.cursor'));

    

    class Grid {
        constructor(el) {
            this.DOM = {el: el};
            // The grid element
            this.DOM.grid = this.DOM.el.querySelector('.grid');
            // Thr grid items
            this.DOM.items = [...this.DOM.grid.children];
            this.DOM.items.forEach(item => {
                const rand = Math.random() < 0.5;
                item.style.transformOrigin = rand ? '0% 0%' : '100% 0%';
                item.dataset.rotateDir = rand ? 'l' : 'r';
            })
            // totla number of grid items
            this.itemsTotal = this.DOM.items.length;
            // The content element ("behind" the grid)
            this.DOM.content = document.querySelector('.content');
            //elemento que contendra elementos segun la imagen seleccionada
            this.DOM.contentItem = this.DOM.content.querySelector('.content__current__item');
            // Calculate heights of both the grid wrap and the grid, and also:
            // . the difference between them (then used for the grid/mousemove translation)
            // . the number of rows/columns 
            this.calculateSize();
            // The grid will be initially translated so it is in the center
            this.gridTranslation = {x: 0, y: -1*this.extraHeight/2};
            // Linear interpolation easing percentage (for the grid movement on mouse move)
            this.lerpFactor = 0.04;
            this.initEvents();
            requestAnimationFrame(() => this.render());
        }
        calculateSize() {
            // The height of the grid wrap
            this.height = this.DOM.el.offsetHeight;
            // The difference between the height of the grid wrap and the height of the grid. This is the amount we can translate the grid
            this.extraHeight = this.DOM.grid.offsetHeight - this.height;
            // Number of grid columns. The CSS variable --cell-number gives us the number of rows
            this.columns = this.itemsTotal/getComputedStyle(this.DOM.grid).getPropertyValue('--cell-number');
            // The animejs stagger function needs an array [cols,rows]
            this.gridDef = [this.columns, this.itemsTotal/this.columns];
        }
        initEvents() {
            // Window resize event 
            // The lerpFactor will change to 1 so theres no delay when translating the grid (or we would see the gaps on the top and bottom)
            window.addEventListener('resize', () => {
                this.lerpFactor = 1;
                // Recalculate..
                this.calculateSize();
                this.columns = this.itemsTotal/getComputedStyle(this.DOM.grid).getPropertyValue('--cell-number');
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => this.lerpFactor = 0.04, 250);
            });

            this.DOM.items.forEach((item, pos) => {
                // The item's title.
                const title = item.dataset.title;
                const text = item.innerText;
                //contenido de cada imagen del grid
                //const htmlContent = item.querySelector('.grid__item-content');
                // Show the title next to the cursor.
                item.addEventListener('mouseenter', () => {
                    cursor.setTitle(title);
                    this.text = text; // Guardamos el innerText en la propiedad text de la clase
                });
                item.addEventListener('click', () => {
                    this.pos = pos;
                    this.title = title;
                    this.text = text; // Guardamos el innerText en la propiedad text de la clase
                    //asignacion de contenido del grid a variable en el evento click
                    //this.htmlContent = htmlContent;
                    this.showContent();
                    cursor.setTitle(title);
                });
            });
            
            // Show back the grid.
            this.DOM.content.addEventListener('click', () => this.showGrid());
        }
        // This is where the main grid effect takes place
        // Animates the boxes out and reveals the content "behind"
        showContent() {
            if ( this.isAnimating ) {
                return false;
            }
            this.isAnimating = true;
            cursor.setTitle('');
            cursor.DOM.title.style.opacity = 0;
            // Set the content background image and title
            this.DOM.content.style.backgroundImage = this.DOM.items[this.pos].querySelector('.grid__item-inner').style.backgroundImage.replace(/img/g, 'img/large');
            
            //Si esta definido contenido en un elemento del grid, se agrega de hijo al contenedor
            if(this.DOM.items[this.pos].querySelector('.grid__item-content')){
                if(this.DOM.contentItem.querySelector('.grid__item-content')){
                    this.DOM.contentItem.removeChild(this.DOM.contentItem.querySelector('.grid__item-content'));
                }
                this.DOM.contentItem.appendChild(this.DOM.items[this.pos].querySelector('.grid__item-content').cloneNode(true));
            } else{
                if(this.DOM.contentItem.querySelector('.grid__item-content')){
                    this.DOM.contentItem.removeChild(this.DOM.contentItem.querySelector('.grid__item-content'));
                }
            }
            // Scales down and fades out the mouse toggle
            cursor.click();
            cursor.toggle();
            
            this.animation = anime({
                targets: this.DOM.items,
                opacity: [
                    {
                        value: 1, duration: 500
                    },
                    {
                        value: 0, 
                        duration: 500, 
                        easing: 'easeInQuad'
                    }
                ],
                translateY: [
                    {
                        value: 0, duration: 500
                    },
                    {
                        value: () => anime.random(100,400), 
                        duration: 500, 
                        easing: 'easeInQuad'
                    }
                ],
                rotate: [
                    {
                        value: target => target.dataset.rotateDir === 'l' ? anime.random(2,15) : anime.random(-0,-15), 
                        duration: 500, 
                        easing: 'easeInOutSine'
                    },
                    {
                        value: target => target.dataset.rotateDir === 'l' ? 8 : -8, 
                        duration: 500, 
                        easing: 'easeInQuad'
                    }
                ],
                delay: anime.stagger(350, {grid: this.gridDef, from: this.pos})
            });
            this.animation.play();
            this.animation.finished.then(() => {
                // Pointer events class
                this.DOM.el.classList.add('grid-wrap--hidden');
                this.isAnimating = false;
            });
        }
        showGrid() {
            if ( this.isAnimating ) {
                return false;
            }
            this.isAnimating = true;
            cursor.click();
            cursor.toggle();
            this.DOM.el.classList.remove('grid-wrap--hidden');
            // Could have used the reverse() but there seems to be a bug (glitch)..
            this.animation = anime({
                targets: this.DOM.items,
                duration: 300,
                easing: 'easeOutExpo',
                opacity: [0,1],
                translateY: [200, 0],
                rotate: [0,0],
                delay: anime.stagger(70, {grid: this.gridDef, from: this.pos})
            });
            this.animation.finished.then(() => this.isAnimating = false);
        }
        // Translate the grid when moving the mouse
        render() {
            // The translation will be either 0 or -1*this.extraHeight depending on the position of the mouse on the y-axis
            this.gridTranslation.y = MathUtils.lerp(this.gridTranslation.y, Math.min(Math.max(MathUtils.lineEq(-1*this.extraHeight, 0, this.height-this.height*.1, this.height*.1, mousePos.y), -1*this.extraHeight),0), this.lerpFactor);
            this.DOM.grid.style.transform = `translateY(${this.gridTranslation.y}px)`; 
            requestAnimationFrame(() => this.render());
        }
    }

    // Initialize the grid
    const grid = new Grid(document.querySelector('.grid-wrap'));

// Preload all the images in the page
    imagesLoaded(document.querySelectorAll('.grid__item-inner, img'), { background: true }, () => {
        document.body.classList.remove('loading');

        const gridContainer = document.querySelector('.grid-reveal-custom');
        //const contentDiv = document.querySelector('.content');

        const cursor = new CursorFx(document.querySelector('.cursor'));
        
        const gridReveal = document.querySelector('.grid-reveal-custom');
        const GridAnimation = (e) => {
            const mouseY = e.clientY; // Obtiene la posición Y del mouse
            const containerTop = gridReveal.getBoundingClientRect().top; // Posición superior del contenedor
            const containerHeight = gridReveal.offsetHeight; // Altura del contenedor
        
            // Verifica si el cursor está dentro del contenedor
            if (mouseY >= containerTop && mouseY <= containerTop + containerHeight) {
                // Calcula la posición vertical normalizada dentro del contenedor
                const normalizedY = (mouseY - containerTop) / containerHeight;
        
                // Aplica la transformación al grid basada en la posición normalizada
                const translateY = MathUtils.lerp(-1 * grid.extraHeight / 2, 0, normalizedY);
                grid.DOM.grid.style.transform = `translateY(${translateY}px)`;
            }
        };
        // Agregar evento cuando el mouse entra en el contenedor
        gridContainer.addEventListener('mouseenter', toggleCursorAnimationEnter);

        // Agregar evento cuando el mouse sale del contenedor
        gridContainer.addEventListener('mouseleave', toggleCursorAnimationLeave);

        
        // Agregar evento cuando el mouse entra en el contenedor
        gridReveal.addEventListener('mousemove', GridAnimation);


        // Función para activar/desactivar la animación del cursor circular
        const toggleCursorAnimationEnter = () => {
            cursor.DOM.title.style.opacity = 1;
        };

        const toggleCursorAnimationLeave = () => {
            cursor.setTitle('');
            cursor.DOM.title.style.opacity = 0;
            
        };
        // Agregar evento cuando el mouse entra en el contenedor
        gridContainer.addEventListener('mouseenter', toggleCursorAnimationEnter);

        // Agregar evento cuando el mouse sale del contenedor
        gridContainer.addEventListener('mouseleave', toggleCursorAnimationLeave);

       
    });

 // Obtén todos los elementos contenedores con la clase '.grid__item'
var gridItems = document.querySelectorAll('.grid__item');

// Recorre los elementos contenedores
gridItems.forEach(function(item) {
    
    // Encuentra los elementos <p> con la clase '.description' dentro del contenedor actual
    var descriptionElements = item.querySelectorAll('.description p');

    // Recorre los elementos <p> y aplica la lógica de ajuste de color
    descriptionElements.forEach(function(element) {
        
        element.style.color = 'white';
        
    });
});



}



